import { render, staticRenderFns } from "./Duplicate.vue?vue&type=template&id=2a12dd1c&"
import script from "./Duplicate.vue?vue&type=script&lang=js&"
export * from "./Duplicate.vue?vue&type=script&lang=js&"
import style0 from "./Duplicate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Duplicate.vue"
export default component.exports